import { LogLevel, PassedInitialConfig } from 'angular-auth-oidc-client';
import { environment } from '@environment/environment';

export const authConfig: PassedInitialConfig = {
  config: {
    authority: `https://cognito-idp.${environment.aws.region}.amazonaws.com/${environment.aws.userPoolId}`,
    redirectUrl: environment.aws.redirectUrl,
    clientId: environment.aws.userPoolWebClientId,
    scope: 'aws.cognito.signin.user.admin email openid phone profile',
    responseType: 'code',
    postLogoutRedirectUri: environment.aws.postLogoutRedirectUrl,
    allowUnsafeReuseRefreshToken: true,
    useRefreshToken: true,
    renewTimeBeforeTokenExpiresInSeconds: 30,
    silentRenew: true,
    secureRoutes: [environment.apiBaseUrl],
    triggerAuthorizationResultEvent: true,
    logLevel: LogLevel.Debug,
  }
};
